module.exports = __webpack_public_path__ + "img/te.a20b95eb.jpg";